import {
  takeLatest,
  call,
  put,
  take,
  cancelled
} from 'redux-saga/effects'
import {
  removeTables,
} from 'containers/Entity/actions'
import {
  loadProjectFormData,
} from 'containers/Project/actions'
import {
  clearFormElements,
} from 'containers/Form/actions'
import {
  FETCH_FORM_DATA,
} from './constants'
import {
  fetchFormDataStart,
  fetchFormDataSuccess,
  fetchFormDataError,
  startFetchFormDataAsync,
} from './actions'

function* fetchFormData(projectId) {
  try {
    yield put(startFetchFormDataAsync())
    yield put(fetchFormDataStart())
    yield put(loadProjectFormData(projectId))
    yield put(fetchFormDataSuccess())
  } catch(error) {
    yield put(fetchFormDataError(error))
  } finally {
    if(yield cancelled()) {
      yield put(clearFormElements())
      yield put(removeTables('elements'))
    }
  }
}

function* loadFormDataHandler(action) {
  const { projectId } = action
  yield call(fetchFormData, projectId)
}

function* watchLoadFormData() {
  yield takeLatest(FETCH_FORM_DATA, loadFormDataHandler)
}

export {
  watchLoadFormData,
  fetchFormData
}
